export default function drawHome() {
    console.log('drawTabletHome')
    let { width, height } = document.getElementById('home').getBoundingClientRect();
    let canvas = document.getElementById('homeCanvas');
    canvas.width = width;
    canvas.height = height;
    let mX = width / 2, mY = height / 2;
    let r = Math.min(mX, mY, width/2.5) - 30;
    let c = canvas.getContext('2d');
    c.globalAlpha = 0.5;
    let pattern = c.createLinearGradient(0, height, width, 0)
    pattern.addColorStop(0.2, '#e1b420')
    pattern.addColorStop(0.5, '#faf5f0')
    pattern.addColorStop(0.8, '#e1b420')
    c.strokeStyle = pattern;
    c.lineWidth = 16;
    let points = pentagonPoints();
    pathFromPoints(points);
    c.stroke();
    let buttons = document.querySelectorAll('#home .optionBtn');
    for (let b = 0; b < buttons.length; b++) {
        let { width: wB, height: hB } = buttons[b].getBoundingClientRect();
        buttons[b].style.left = `${mX - wB/2}px`;
        buttons[b].style.top = `${mY - hB/2}px`;
        buttons[b].style.transform = `rotate(${b * 72}deg) translateY(-${r}px) rotate(-${b * 72}deg)`
    }

    // text blurb at bottom
    // not sure why, but when I drew this with canvas, rockwell font displayed slightly differently then it did with simple html/css
    // let { width: blurbW, height: blurbH } = document.getElementById('homeBlurb').getBoundingClientRect(); 
    // let blurbCanvas = document.getElementById('blurbCanvas')
    // let blurb = blurbCanvas.getContext('2d');
    // blurb.fillStyle = '#faf5f0';
    // blurb.textAlign = 'center'
    // blurb.font = '20px Rockwell'
    // let tagline = "Welcome!"
    // blurb.fillText(tagline, 150, 40, width)


    function pentagonPoints(angle = 0) {
        let points = [];
        let theta = Math.PI * 2 / 5;
        for (let i = 0; i < 5; i++) {
            points.push([mX + r * Math.sin(angle), mY - r * Math.cos(angle)])
            angle += theta;
        }
        return points;
    }

    function pathFromPoints(points) {
        c.beginPath();
        c.moveTo(points[0][0], points[0][1]);
        for (let i = 1; i < points.length; i++) {
            c.lineTo(points[i][0], points[i][1])
        }
        c.closePath();
    }

}